import { Input } from "reactstrap";

import useHelpers from "Hooks/useHelpers";
import styles from "components/ReactTable/Components/DefaultColumnFilter/DefaultColumnFilter.module.css";
import React, { useState } from "react";

/** This is the default column filter used in React Table. Can be passed a boolean
 * autoFocus to specify that the input should be focused on page load.
 * @param column - The column object for the filter.
 * @param autoFocus - Whether or not to autofocus the input. Default = false.
 * @example
 * In React table column definition in parent of React table:
 * ``` Filter: ({ column }: any) => {
                return <DefaultColumnFilter column={column} autoFocus />;
            },``` 
    OR
    ``` Filter: ({ column }: any) => {
                    return <DefaultColumnFilter column={column} />;
            }```

 */
export default function DefaultColumnFilter({
    column,
    autoFocus = false,
}: {
    column: any;
    autoFocus: boolean;
}) {
    const [term, setTerm] = useState("");
    const { setFilter } = column;

    const { debounce } = useHelpers();

    const debouncedSetFilter = debounce(setFilter, 200);

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value || undefined;
        setTerm(value || "");
        debouncedSetFilter(value);
    }

    return (
        <Input
            autoFocus={autoFocus}
            type="search"
            className={styles.searchInput}
            value={term || ""}
            // Stop the click to select the search input from bubbling up and triggering a sort
            onClick={(e) => e.stopPropagation()}
            onChange={handleChange}
            placeholder={`Search ...`}
            // Highlight the text input background if column is being filtered
            style={{
                ...(column.filterValue
                    ? {
                          backgroundColor: "var(--dimensionBlueHighlight)",
                      }
                    : {}),
            }}
        />
    );
}
